export default {
	onlineActorListItem:
		"<li><a class='OnlineActor' data-remote='true'>\
			<div class='AvatarSet AvatarSet--small-small'></div>\
			<div class='OnlineActor__names'>\
				<span class='actor-name'></span><br>\
				<span class='group-name'></span>\
			</div>\
		</li>",
	actorAvatarItem:
		"<div class='Avatar Avatar--small Avatar--bordered'>\
			<div class='Avatar__image'></div>\
		</div>",
	actorAvatarChairIcon:
		"<span class='Avatar__icon senaryon-icon senaryon-icon-star'></span>",

	/**
	 * Set list of online Actors in navbar
	 */
	setOnlineActorsList: () => {
		if (typeof VueStore === "undefined") {
			return;
		}
		const gameActors = VueStore.getters.gameActors();
		let onlineActors = Object.entries(gameActors).filter(
			([actorId, actorItem]) => {
				return actorItem.isOnline == true;
			},
		);
		// pp.log("StickyButtons set onlineList -- onlineActors count:", onlineActors.length);

		const $onlineActorsSpan = $(".j-online-actors-count");
		const oldHtml = $onlineActorsSpan.html();
		// @ts-expect-error
		$onlineActorsSpan.html(onlineActors.length);
		if ($onlineActorsSpan.html() != oldHtml && oldHtml != "") {
			pp.stickyButtons.setHighlightHelper(
				$(".Sticky-button--online-actors"),
				"Sticky-button--highlight-blue",
				"onlineActorsHighlightTimeout",
			);
		}
		const $list = $(".OnlineActors");
		if (!$list.length) {
			return;
		}

		onlineActors.forEach(([actorId, actorElem]) => {
			const $newEl = $(pp.stickyButtons.onlineActorListItem);
			// Actor elements
			let name =
				actorElem.names[I18n.locale] || Object.values(actorElem.names)[0];
			let $avatarItem = $(pp.stickyButtons.actorAvatarItem);
			$avatarItem
				.find(".Avatar__image")
				.css("backgroundImage", `url(${actorElem.imgPath})`);
			$newEl.find(".AvatarSet").append($avatarItem);
			$newEl.find(`.OnlineActor__names .actor-name`).text(name);
			$newEl.find("a").attr("href", `/actors/${actorId}`);
			if (actorElem.functions.indexOf("chair") != -1) {
				$newEl
					.find(".Avatar--small")
					.first()
					.addClass("Avatar--bordered-blue")
					.append(pp.stickyButtons.actorAvatarChairIcon);
			}

			// Group elements
			const principalGroupElem = gameActors[actorElem.principalGroupId];
			name =
				principalGroupElem.names[I18n.locale] ||
				Object.values(principalGroupElem.names)[0];
			$avatarItem = $(pp.stickyButtons.actorAvatarItem);
			$avatarItem
				.find(".Avatar__image")
				.css("backgroundImage", `url(${principalGroupElem.imgPath})`);
			$newEl.find(".AvatarSet").append($avatarItem);
			$newEl.find(`.OnlineActor__names .group-name`).text(name);

			$list.append($newEl);
		});

		if (!$list.children().length) {
			$list.append("<li>&mdash;</li>");
		}
	},

	tasks: {
		$popover: null,

		init() {
			// pp.log("StickyButtons into tasks init");
			$(".Sticky-button--tasks").on(
				"inserted.bs.popover",
				pp.stickyButtons.tasks.loadContent,
			);
		},
		loadContent() {
			const $button = $(this);
			$.get("/games/phase_instructions", (data) => {
				$(".overlay-tasks-list").html(
					data.trim().length ? data : I18n.t("tasks.no_tasks_present"),
				);

				// @ts-expect-error
				pp.stickyButtons.tasks.$popover = $(
					`#${$button.attr("aria-describedby")}`,
				);
				pp.stickyButtons.hideOnClickOutside(pp.stickyButtons.tasks);
			});
		},
	},

	phaseState: {
		$popover: null,

		init() {
			$(".Sticky-button--phase-countdown").on(
				"inserted.bs.popover",
				pp.stickyButtons.phaseState.show,
			);
		},

		show() {
			pp.log("StickyButtons showing PhaseState");
			const $button = $(this);

			// @ts-expect-error
			pp.stickyButtons.phaseState.$popover = $(
				`#${$button.attr("aria-describedby")}`,
			);
			setTimeout(() => {
				pp.stickyButtons.hideOnClickOutside(pp.stickyButtons.phaseState);
			}, 0);

			$(".j-phase-description").html(pp.gameState.phaseDescription);
			$(".j-phase-duration").html(pp.gameState.phaseDuration);
			$(".j-popover--phase-state .j-popover-title").text(
				pp.gameState.phaseName || "-",
			);
			if (pp.gameState.endDate === undefined) {
				// Game is paused or has ended
				// @ts-expect-error
				if (pp.gameState.phaseNumber > 0) {
					// Game is paused
					// @ts-expect-error
					pp.stickyButtons.phaseState.$popover
						.find(".j-unpause-btn")
						.removeClass("hidden");
					// @ts-expect-error
					pp.stickyButtons.phaseState.$popover
						.find(".j-countdown")
						.text(I18n.t("modal_overlays.phase_paused.title"));
				} else {
					// Game has ended or not started yet
					// @ts-expect-error
					pp.stickyButtons.phaseState.$popover.find(".j-countdown").text("-");
				}
				// @ts-expect-error
			} else if (pp.gameState.phaseNumber > 0) {
				// Game is running
				// @ts-expect-error
				pp.stickyButtons.phaseState.$popover
					.find(".j-pause-btn, .j-extend-by-five-min-btn")
					.removeClass("hidden");
				// @ts-expect-error
				pp.stickyButtons.phaseState.$popover
					.find(".j-extend-by-five-min-btn")
					.on("click", pp.phaseManager.extendPhaseByFiveMin);
				const lastPhaseNumber = Object.keys(pp.phaseManager.phaseDurations)[
					Object.keys(pp.phaseManager.phaseDurations).length - 1
				];
				// @ts-expect-error
				const $linkTarget = pp.stickyButtons.phaseState.$popover.find(
					// @ts-expect-error
					pp.gameState.phaseNumber < lastPhaseNumber
						? ".j-start-phase"
						: ".j-conclude-game",
				);
				$linkTarget
					.removeClass("hidden")
					.on("click", pp.phaseManager.endActivePhase);
			}
		},
	},

	notes: {
		$popover: null,

		init() {
			// pp.log("StickyButtons notes init");
			const $button = $("#sticky-notes-button");
			$button.on("inserted.bs.popover", pp.stickyButtons.notes.show);

			// Trigger 'destroyed' on the textarea to invoke unsubscription from the Pad channel
			$button.on("hide.bs.popover", () => {
				// @ts-expect-error
				pp.stickyButtons.notes.$popover.find("textarea").trigger("destroyed");
			});
		},

		show() {
			const $button = $(this);
			// @ts-expect-error
			pp.stickyButtons.notes.$popover = $(
				`#${$button.attr("aria-describedby")}`,
			);

			$.ajax({
				url: `/actors/${pp.currentActorId}/notes.js`,
				type: "GET",
				dataType: "html",
				success: (data) => {
					pp.stickyButtons.hideOnClickOutside(pp.stickyButtons.notes);
					$(".overlay-notes-pad-area").html(data);
				},
				error: (jqXHR, textStatus, errorThrown) => {
					pp.log(
						"loading notes for popover failed",
						jqXHR,
						textStatus,
						errorThrown,
					);
				},
			});
		},
	},

	setHighlightHelper($element, highlightClass, timeoutName) {
		// pp.log("StickyButtons into setHighlightHelper", $element, highlightClass, timeoutName)
		$element.addClass(highlightClass);
		if (!pp.stickyButtons[timeoutName]) {
			pp.stickyButtons[timeoutName] = setTimeout(() => {
				// pp.log("in timeout", timeoutName);
				$element.removeClass(highlightClass);
				pp.stickyButtons[timeoutName] = null;
			}, 3500); // NB the `3500 corresponds to the duration of `3.5s` in LESS
		}
	},

	// Expects a `$popover` to be set on the calling module
	hideOnClickOutside(module) {
		pp.log("stickyNotes init hideOnClickOutside -- target modules", module);
		const $popover = module.$popover;
		if (!$popover.length) {
			return;
		}
		const $popoverButton = $(`[aria-describedby='${$popover[0].id}']`);
		module.checkClickOutside = (event) => {
			// pp.log("click", event, $popover);
			if ($popover[0].contains(event.target)) {
				// pp.log("click inside");
				return;
			}
			// pp.log("click away", $popoverButton, module.checkClickOutside);
			$popoverButton.trigger("click");
		};
		$(document).on("click", module.checkClickOutside);

		$popoverButton.one("hide.bs.popover", () => {
			// pp.log("hide", module.checkClickOutside);
			$(document).off("click", module.checkClickOutside);
			module.checkClickOutside = null;
			module.$popover = null;
		});

		module.$popover.find("a.close").one("click", () => {
			$popoverButton.trigger("click");
		});
	},
};
